"use client";

import { c as _c } from "react/compiler-runtime";
import React, { Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useDebouncedValue } from "../hooks/useDebouncedValue";
import styles from "./SearchBar.module.css";
interface SearchBarProps {
  onSearch: (query: string) => void;
}
function SearchBarContent(t0) {
  const $ = _c(19);
  const {
    onSearch
  } = t0;
  const router = useRouter();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("q") || "";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const urlQuery = t1;
  const [inputValue, setInputValue] = React.useState(urlQuery);
  const debouncedQuery = useDebouncedValue(inputValue, 250);
  const lastProcessedQuery = React.useRef(urlQuery);
  const hasTriggeredInitialSearch = React.useRef(false);
  let t2;
  let t3;
  if ($[2] !== onSearch || $[3] !== urlQuery) {
    t2 = () => {
      if (!hasTriggeredInitialSearch.current && urlQuery) {
        hasTriggeredInitialSearch.current = true;
        lastProcessedQuery.current = urlQuery;
        onSearch(urlQuery);
      }
    };
    t3 = [urlQuery, onSearch];
    $[2] = onSearch;
    $[3] = urlQuery;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  React.useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== debouncedQuery || $[7] !== onSearch || $[8] !== router) {
    t4 = () => {
      if (debouncedQuery === lastProcessedQuery.current) {
        return;
      }
      lastProcessedQuery.current = debouncedQuery;
      const params = new URLSearchParams();
      if (debouncedQuery.trim()) {
        params.set("q", debouncedQuery.trim());
      }
      const newUrl = params.toString() ? `?${params.toString()}` : "/";
      router.replace(newUrl, {
        scroll: false
      });
      onSearch(debouncedQuery.trim());
    };
    t5 = [debouncedQuery, router, onSearch];
    $[6] = debouncedQuery;
    $[7] = onSearch;
    $[8] = router;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  React.useEffect(t4, t5);
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = e => {
      setInputValue(e.target.value);
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleInputChange = t6;
  const handleSubmit = _temp;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setInputValue("");
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleClear = t7;
  let t8;
  let t9;
  if ($[13] !== inputValue) {
    t8 = <input type="text" value={inputValue} onChange={handleInputChange} placeholder="Search for GIFs..." className={styles.input} autoComplete="off" spellCheck="false" />;
    t9 = inputValue && <button type="button" onClick={handleClear} className={styles.clearButton}>✖︎</button>;
    $[13] = inputValue;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <form onSubmit={handleSubmit} className={styles.form}><div className={styles.inputContainer}>{t8}{t9}</div></form>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}
function _temp(e_0) {
  e_0.preventDefault();
}
export default React.memo(function SearchBar(t0) {
  const $ = _c(3);
  const {
    onSearch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className={styles.searchBarFallback}>Loading search...</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onSearch) {
    t2 = <Suspense fallback={t1}><SearchBarContent onSearch={onSearch} /></Suspense>;
    $[1] = onSearch;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
});